import { createFileRoute } from "@tanstack/react-router";
import BreadcrumbJsonLd from "@/components/common/breadcrumbJsonLd";

const BASE_URL = "https://datafirstjobs.com";
const SITE_URL = `${BASE_URL}/post-job`;

export const Route = createFileRoute("/post-job")({
  head: () => ({
    meta: [
      { title: "Post a Job | Data First Jobs" },
      {
        name: "description",
        content:
          "Post your data engineering, analytics, or data science job on Data First Jobs and reach thousands of qualified candidates.",
      },
      { property: "og:title", content: "Post a Job | Data First Jobs" },
      {
        property: "og:description",
        content:
          "Post your data job on Data First Jobs and reach thousands of qualified candidates.",
      },
      { property: "og:url", content: SITE_URL },
    ],
    links: [{ rel: "canonical", href: SITE_URL }],
  }),
  component: PostJobPage,
});

function PostJobPage() {
  return (
    <>
      <BreadcrumbJsonLd
        items={[
          { name: "Home", url: BASE_URL },
          { name: "Post a Job" },
        ]}
      />
      <div className="mx-auto max-w-2xl px-4 py-16 text-center sm:py-24">
        <h1 className="text-polaris-navy mb-4 text-3xl font-semibold tracking-tight sm:text-4xl">
          Post a Job
        </h1>
        <p className="mb-2 text-lg text-gray-600">Coming soon.</p>
        <p className="text-gray-600">
          For enquiries, please reach out to{" "}
          <a
            href="mailto:laszlo@datafirstjobs.com"
            className="text-polaris-orange transition-colors hover:text-orange-700"
          >
            laszlo [at] datafirstjobs.com
          </a>
          .
        </p>
      </div>
    </>
  );
}
